"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewLinkBanner = require("./NewLinkBanner");
Object.keys(_NewLinkBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewLinkBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewLinkBanner[key];
    }
  });
});